import React from "react";
import Couriers from "views/Dashboard/Couriers.js";
import Merchants from "views/Dashboard/Merchants.js";
import Invoices from "views/Dashboard/Invoices.js";
import Leads from "views/Dashboard/Leads.js";
import { StatsIcon, CartIcon, InvisionLogo } from "components/Icons/Icons";
import ImportCenter from "views/Dashboard/import";
import ProgressTracking from "views/Dashboard/progress-tracking";
import { OrderDetails } from "views/Dashboard/order-details";
import orders from "views/Dashboard/Orders";
import { Role } from "./variables/Roles";
import Customers from "views/Dashboard/Customers";
import PricingPlans from "views/Dashboard/pricing-plans";
import PricingPlansDetails from "views/Dashboard/pricing-plans-details";
import CommercialCampaigns from "views/Dashboard/commercial-campaigns";
import {
  BiSolidBox,
  BiSolidTruck,
  BiSolidCart,
  BiSolidFile,
  BiSolidFilterAlt,
  BiSolidFileImport,
  BiSolidTimeFive,
  BiSolidUser,
  BiSolidPaperPlane,
  BiSolidNotification,
} from "react-icons/bi";
import Dispute from "views/Dashboard/Dispute";
import NDR from "views/Dashboard/NDR";

const accessLvl = localStorage.getItem("role")
  ? localStorage.getItem("role")
  : "";

var dashRoutes = [
  {
    path: "/orders",
    name: "Orders",
    icon: <BiSolidBox color="inherit" />,
    component: orders,
    layout: "/admin",
    validation: () => true,
  },
  {
    path: "/orders/dispute",
    name: "Dispute",
    icon: <BiSolidFileImport color="inherit" />,
    component: Dispute,
    layout: "/admin",
    validation: () => true,
  },
  {
    path: "/ndr",
    name: "NDR",
    icon: <BiSolidNotification color="inherit" />,
    component: NDR,
    layout: "/admin",
    validation: () => true,
  },
  {
    path: "/couriers",
    name: "Couriers",
    icon: <BiSolidTruck color="inherit" />,
    component: Couriers,
    layout: "/admin",
    validation: () => true,
  },
  {
    path: "/merchants",
    name: "Merchants",
    icon: <BiSolidCart color="inherit" />,
    component: Merchants,
    layout: "/admin",
    validation: () =>
      accessLvl === Role.superFinance || accessLvl === Role.financeManager,
  },
  {
    path: "/invoices",
    name: "Invoices",
    icon: <BiSolidFile color="inherit" />,
    component: Invoices,
    layout: "/admin",
    validation: () => accessLvl === Role.superFinance,
  },
  {
    path: "/leads",
    name: "Leads",
    icon: <BiSolidFilterAlt color="inherit" />,
    component: Leads,
    layout: "/admin",
    validation: () => true,
  },
  {
    path: "/import",
    name: "Import",
    icon: <BiSolidFileImport color="inherit" />,
    component: ImportCenter,
    layout: "/admin",
    validation: () => true,
  },
  {
    path: "/progress-tracking",
    name: "Progress Tracking",
    icon: <BiSolidTimeFive color="inherit" />,
    component: ProgressTracking,
    layout: "/admin",
    validation: () => true,
  },
  {
    path: "/customers",
    name: "Customers",
    icon: <BiSolidUser color="inherit" />,
    component: Customers,
    layout: "/admin",
    validation: () => true,
  },
  {
    path: "/pricing-plans",
    name: "Pricing Plans",
    icon: <BiSolidPaperPlane color="inherit" />,
    component: PricingPlans,
    layout: "/admin",
    validation: () =>
      accessLvl === Role.superFinance || accessLvl === Role.financeManager,
  },
  {
    path: "/commercial-campaigns",
    name: "Commercial Campaigns",
    icon: <BiSolidNotification color="inherit" />,
    component: CommercialCampaigns,
    layout: "/admin",
    validation: () =>
      accessLvl === Role.superFinance || accessLvl === Role.financeManager,
  },
  {
    path: "/orders/:id/details",
    name: "Order Details",
    icon: <BiSolidBox color="inherit" />,
    component: OrderDetails,
    layout: "/admin",
    hide: true,
    validation: () => true,
  },
  {
    path: "/pricing-plans/:id/details",
    name: "Pricing Plans Details",
    icon: <BiSolidPaperPlane color="inherit" />,
    component: PricingPlansDetails,
    layout: "/admin",
    hide: true,
    validation: () =>
      accessLvl === Role.superFinance || accessLvl === Role.financeManager,
  },
  {
    path: "/merchants/:id/plan-details",
    name: "Merchant Pricing Plan Details",
    icon: <BiSolidPaperPlane color="inherit" />,
    component: PricingPlansDetails,
    layout: "/admin",
    hide: true,
    validation: () =>
      accessLvl === Role.superFinance || accessLvl === Role.financeManager,
  },
];
export default dashRoutes;
